<template>
  <a-form-model ref="informationForm" :model="form" :rules="rules">
    <a-row :gutter="12">
      <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
        <a-form-model-item label="Tanggal Permohonan" prop="tgl_permohonan">
          <a-date-picker :disabled="disabled" :format="getDefaultDateFormat" type="date" v-model="form.tgl_permohonan" />
        </a-form-model-item>
        <a-form-model-item label="Financing No" prop="financing_no">
          <a-select v-model="form.financing_no" :disabled="disabled" placeholder="Select Financing Number">
            <a-select-option class="select-between" v-for="item in initial.financing" :key="item.id" :value="item.id">
              <div class="select-option">
                <h4>{{ item.no }}</h4>
                <small>{{ formatCurrency("", item.value) }}</small>
              </div>
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="Project" prop="contract_no">
          <a-select allowClear showSearch option-filter-prop="children" :filter-option="handleOption" :disabled="disabled"
            v-model="form.contract_no" placeholder="Select Project">
            <a-select-option class="select-between" v-for="item in initial.contract" :key="item.id" :value="item.id">
              <div class="select-option">
                <h4>{{ item.no + " - (" + item.cost_center + ")" }}</h4>
                <small>{{ formatCurrency(item.currency, item.value) }}</small>
              </div>
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="Request Number" prop="no_permohonan">
          <a-input class="m-width-full" v-model="form.no_permohonan"></a-input>
        </a-form-model-item>
        <a-form-model-item label="File Support" prop="file_support">
          <a-upload :fileList="push" v-model="form.file_support" :remove="handleRemove" :beforeUpload="beforeUpload">
            <a-button>
              <a-icon type="upload" />Select File
            </a-button>
          </a-upload>
        </a-form-model-item>
      </a-col>
      <a-col :span="12">
        <a-form-model-item label="Value" prop="value">
          <a-input-number :disabled="disabled" class="m-width-full m-text-align-right" :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            " :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')" v-model="form.value"></a-input-number>
        </a-form-model-item>
        <a-form-model-item label="Admin Value" prop="admin_value">
          <a-input-number class="m-width-full m-text-align-right" :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            " :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')" v-model="form.admin_value">
            :min="0"</a-input-number>
        </a-form-model-item>
        <a-form-model-item label="Provision Value" prop="provisi_value">
          <a-input-number class="m-width-full m-text-align-right" :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            " :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')" v-model="form.provisi_value"
            :min="0"></a-input-number>
        </a-form-model-item>
        <a-form-model-item label="Description" prop="description">
          <a-textarea v-model="form.description" :rows="2"> </a-textarea>
        </a-form-model-item>
      </a-col>
    </a-row>
  </a-form-model>
</template>

<script>
import { mapGetters } from "vuex";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import _ from "lodash";
import moment from "moment";

export default {
  name: "penarikan-financing-informasi",
  props: ["mode"],
  data() {
    let doc_validation = (rule, value, callback) => {
      if (this.push == null || this.push.length == 0) {
        callback(new Error("Please input File Support"));
      } else {
        callback();
      }
    };
    return {
      form: {
        tgl_permohonan: null,
        financing_no: null,
        contract_no: null,
        value: null,
        admin_value: 0,
        provisi_value: 0,
        no_permohonan: null,
        description: null,
        file_support: [],
      },
      rules: {
        tgl_permohonan: [
          {
            required: true,
            message: "Please pick tanggal permohonan",
            trigger: "change",
          },
        ],
        financing_no: [
          {
            required: true,
            message: "Please select no financing",
            trigger: "change",
          },
        ],
        contract_no: [
          {
            required: false,
            message: "Please select no contract",
            trigger: "change",
          },
        ],
        value: {
          required: true,
          message: "Please input value",
          trigger: "blur",
        },
        description: {
          required: true,
          message: "Please input description",
          trigger: "blur",
        },
        file_support: {
          required: true,
          validator: doc_validation,
          message: "Please input File Support",
          trigger: "change",
        },
      },
      initial: {},
      disabled: false,
      push: [],
    };
  },
  mixins: [CurrencyFormat],
  computed: {
    ...mapGetters([
      "getAuth",
      "getScreen",
      "getDefaultDateFormat",
      "getStandartFormatDate",
      "getPenarikanInformationFinancing",
      "getPageMode",
      "getInitial",
    ]),
    selectedFinancing() {
      let outputData = this.initial.financing;
      if (this.form.financing_no !== null) {
        outputData = _.filter(
          outputData,
          (obj) => obj.id.indexOf(this.form.financing_no) >= 0
        );
      }

      return outputData[0];
    },
  },
  watch: {
    getPenarikanInformationFinancing() {
      this.fetch();
      this.initialData();
    },
  },
  mounted() {
    this.fetch();
    this.initialData();
  },
  methods: {
    moment,
    fetch() {
      if (this.getPageMode === "Create") {
        this.$store
          .dispatch("getAllInputData", { auth: this.getAuth })
          .then((res) => {
            this.initial = {
              contract: res.contract,
              financing: res.financing,
            };
          });
      } else {
        this.initial = {
          contract: this.getInitial.contract,
          financing: this.getInitial.financing,
        };
      }
    },
    initialData() {
      this.disabled = this.getPageMode === "Edit" ? true : false;
      this.form = {
        tgl_permohonan: this.getPenarikanInformationFinancing.tgl_permohonan
          ? moment(this.getPenarikanInformationFinancing.tgl_permohonan, this.getStandartFormatDate)
          : null,
        financing_no: this.getPenarikanInformationFinancing.financing_no
          ? this.getPenarikanInformationFinancing.financing_no
          : undefined,
        contract_no: this.getPenarikanInformationFinancing.contract_no
          ? this.getPenarikanInformationFinancing.contract_no
          : undefined,
        value: this.getPenarikanInformationFinancing.value
          ? this.getPenarikanInformationFinancing.value
          : null,
        admin_value: this.getPenarikanInformationFinancing.admin_value
          ? this.getPenarikanInformationFinancing.admin_value
          : 0,
        provisi_value: this.getPenarikanInformationFinancing.provisi_value
          ? this.getPenarikanInformationFinancing.provisi_value
          : 0,
        no_permohonan: this.getPenarikanInformationFinancing.no_permohonan
          ? this.getPenarikanInformationFinancing.no_permohonan
          : null,
        description: this.getPenarikanInformationFinancing.description
          ? this.getPenarikanInformationFinancing.description
          : null,
        file_support: this.getPenarikanInformationFinancing.file_support
          ? this.getPenarikanInformationFinancing.file_support
          : null,
      };

      if (this.getPenarikanInformationFinancing.file_support) {
        this.push = []
        this.push.push(this.getPenarikanInformationFinancing.file_support[0])
      }
    },
    handleRef() {
      this.$refs.informationForm.validate((valid) => {
        if (!valid) {
          this.displayMessage("form-warning");
          return;
        }

        if (this.getPageMode === "Create") {
          if (
            parseFloat(this.form.value) == 0 ||
            parseFloat(this.form.value) >
            parseFloat(this.selectedFinancing.value)
          ) {
            this.displayMessageValue(
              "basic-error",
              "Value tidak boleh 0 atau lebih besar dari value financing!"
            );
            return;
          }
        }
        this.$store.commit("setInformation", this.form);
        Event.$emit("dataProcessed", this.form);
      });
    },
    handleOption(input, option) {
      return (
        option.componentOptions.children[0].children[0].children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 30) {
        this.displayMessage("large-file-2mb");
      } else if (this.fungsi === "") {
        this.displayMessage("error-emptyDoc");
      } else {
        this.push.push(file)
        this.form.file_support = [];
        this.form.file_support.push(file)
        return false;
      }
    },
    handleRemove() {
      this.push = [];
      this.form.file_support = [];
    }

  },
};
</script>

<style lang="less">
.select {
  &-option {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex: 1;

    >div {
      display: flex;
      gap: @padding / 2;
    }
  }

  &-between {
    .ant-select-selection {
      display: flex;

      &__rendered {
        flex: 1;
        padding-right: @padding;
        display: flex;
      }

      &-selected-value {
        flex: 1;
      }
    }
  }
}

.ant-select-selection-selected-value {
  width: 100%;
}
</style>
